export default __webpack_public_path__ + "static/media/watch_1.4fd71d7d.jpg";